$.validator.addMethod('reclamacaoRequired', function (value, element, param) {
    const val = $(".contact-form select[name='assunto']").val();
    if (val == '0060' && !value) {
        return false;
    }

    return true;
});

$.validator.addMethod('solicitacaoRequired', function (value, element, param) {
    const val = $(".contact-form select[name='assunto']").val();
    if (val == '0070' && !value) {
        return false;
    }

    return true;
});

$.validator.addMethod('cep', function (value, element, param) {
    var cepPattern = /^[0-9]{5}-[0-9]{3}$/;
    return cepPattern.test(value);
});

jQuery.validator.addMethod(
    'validDate',
    function (dateString, element) {
        // Verifique se a data está no formato DD/MM/YYYY
        var datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
        if (!datePattern.test(dateString)) {
            return false;
        }

        // Parse a data em dia, mês e ano
        var parts = dateString.split('/');
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10);
        var year = parseInt(parts[2], 10);

        // Verifique se o ano é válido (por exemplo, maior que 1900)
        if (year < 1900) {
            return false;
        }

        // Verifique se o mês está no intervalo de 1 a 12
        if (month < 1 || month > 12) {
            return false;
        }

        // Verifique se o dia está no intervalo correto para o mês
        var maxDay = new Date(year, month, 0).getDate();
        if (day < 1 || day > maxDay) {
            return false;
        }

        return true;
    },
    'Data precisa ter o formato DD/MM/YYYY'
);
